import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
});

export const websiteContainer = css({
  marginTop: '3x',
});
